// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const updateShowSelectAll = showSelectAll => ({
    showSelectAll,
    type: actions.UPDATE_CREDIT_MEMO_SHOW_SELECT_ALL
});



// WEBPACK FOOTER //
// ./src/reports/credit-memo/action-creators/show-select-all.js